import { QrScanResult, QrTokenType } from 'core/enums';

export interface QrScanLogItemModel {
    date: string;
    userName: string;
    type: string | null;
    entityGuid: string | null;
    result: string | null;
    ip: string | null;
    deviceType: string | null;
    deviceId: string | null;
}

export interface QrScanLogRequestModel {
    date?: string;
    userName?: string;
    type?: QrTokenType;
    result?: QrScanResult;
    page: number;
    pageSize: number;
    orderBy?: string;
    reverse?: boolean;
}
